import { DatePipe } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { DisabilityProof } from '../../../../api/app-types/disability-proof.app';
import { DisabilityStatusInitial } from '../../../../api/app-types/disability-status.app';
import { DOCUMENT_CATEGORY, DocumentFile, DocumentNavItem } from '../../../../api/app-types/document.app';

@Component({
	selector: 'lvr-disability-proof-item',
	templateUrl: './disability-proof-item.html',
	styleUrl: './disability-proof-item.scss',
	imports: [TranslocoPipe, DatePipe],
})
export class DisabilityProofItem {
	private readonly router = inject(Router, { optional: true });

	public readonly proof = input.required<DisabilityProof>();
	public readonly shouldShowOtherText = computed(() => this.proof().status.content === 'Sonstiges:');
	private readonly sbStatusDurationRequired = new Set<DisabilityStatusInitial>([
		DisabilityStatusInitial.SEVERELY_DISABLED,
		DisabilityStatusInitial.EQUALIZED,
	]);
	public readonly shouldShowSbStatusDurationInfo = computed(() =>
		this.sbStatusDurationRequired.has(this.proof().status.initial as DisabilityStatusInitial),
	);

	public openDocument(event: MouseEvent, file: DocumentFile) {
		if (!this.router) return;

		const clientId = this.resolveClientId();
		if (!clientId) return;

		event.preventDefault();
		event.stopPropagation();

		this.router.navigate(['/desk/client', clientId, 'documents', file.id], {
			state: { navItems: this.buildDisabilityProofNavItems(this.proof()) },
		});
	}

	private resolveClientId(): string | null {
		if (!this.router) return null;

		const match = this.router.url.match(/\/desk\/client\/([^/]+)/);

		return match?.[1] ?? null;
	}

	private buildDisabilityProofNavItems(proof: DisabilityProof): DocumentNavItem[] {
		const files = proof.documents ?? [];
		const entryName = proof.categoryDisabilityStatus.remark || '-';
		const createdAt = proof.since ?? new Date();

		return files.map((file) => ({
			file,
			entryId: proof.id,
			entryName,
			category: DOCUMENT_CATEGORY.DISABILITY_REPORT,
			createdAt,
			isReport: false,
			isFrozen: false,
		}));
	}
}
